import { Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/components/Page";
import StateTrendContent from "@/components/Trend/StateTrendContent";

function TilstandsutviklingPage() {
  return (
    <Page contentPadding maxWidth="xl">
      <Typography align="center" sx={{ my: 3 }} variant="h1">
        Tilstandsutvikling
      </Typography>
      <StateTrendContent />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/tilstandsutvikling")({
  component: TilstandsutviklingPage,
});
